import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const BuyBtn = styled(Button)({
  height: "48px",
  lineHeight: "48px",
  maxHeight: "48px",
  width: "100%",
  color: "#14D1B2",
  fontSize: 14,
  fontFamily: "Gilroy-Bold",
  textTransform: "uppercase",
  background: "transparent",
  border: "1px solid",
  borderColor: "#14D1B2",
  borderRadius: "8px",
  ".browserIcon": {
    marginLeft: "12px",
  },
  "&:hover": {
    background: "rgba(20, 209, 178, 0.4)",
    color: "#14D1B2",
    ".browserIcon": {
      path: {
        fill: "#14D1B2",
        stroke: "#14D1B2",
      },
    },
  },
});
